"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CardState = (_class = /*#__PURE__*/function (_RootState) {
  function CardState(card) {
    var _this;
    _classCallCheck(this, CardState);
    _this = _callSuper(this, CardState);
    _initializerDefineProperty(_this, "textEntry", _descriptor, _this);
    _initializerDefineProperty(_this, "addToReviews", _descriptor2, _this);
    _initializerDefineProperty(_this, "revealed", _descriptor3, _this);
    _initializerDefineProperty(_this, "helpWasShown", _descriptor4, _this);
    _initializerDefineProperty(_this, "helpWord", _descriptor5, _this);
    _initializerDefineProperty(_this, "submittedToFeed", _descriptor6, _this);
    _initializerDefineProperty(_this, "submittingToFeed", _descriptor7, _this);
    _initializerDefineProperty(_this, "submittedToFeedMessageClosed", _descriptor8, _this);
    _initializerDefineProperty(_this, "audioHasAutoPlayed", _descriptor9, _this);
    _initializerDefineProperty(_this, "onboardingTipSeen", _descriptor10, _this);
    _initializerDefineProperty(_this, "lastOnboardingTipSeen", _descriptor11, _this);
    _initializerDefineProperty(_this, "requestedFeedback", _descriptor12, _this);
    _initializerDefineProperty(_this, "vocabCardShowsWord", _descriptor13, _this);
    _initializerDefineProperty(_this, "showHelp", _descriptor14, _this);
    _initializerDefineProperty(_this, "showType", _descriptor15, _this);
    _initializerDefineProperty(_this, "grammarTipSeen", _descriptor16, _this);
    _initializerDefineProperty(_this, "inputValues", _descriptor17, _this);
    _initializerDefineProperty(_this, "selectedOptionText", _descriptor18, _this);
    _this.card = card;
    return _this;
  }
  _inherits(CardState, _RootState);
  return _createClass(CardState, [{
    key: "resetWithinCard",
    value: function resetWithinCard() {
      this.textEntry = '';
      this.requestedFeedback = false;
      this.onboardingTipSeen = null;
      this.addToReviews = false;
      this.submittedToFeed = false;
      this.submittingToFeed = false;
      this.revealed = false;
      this.showHelp = false;
      this.helpWord = null;
      this.audioHasAutoPlayed = false;
      this.vocabCardShowsWord = true;
      this.showHelp = false;
      this.videoPlaying = false;
      this.inputValues = {};
      this.selectedOptionText = null;
    }
  }, {
    key: "markGrammarTipAsSeen",
    value: function markGrammarTipAsSeen() {
      this.grammarTipSeen = true;
    }
  }, {
    key: "toggleShowType",
    value: function toggleShowType() {
      this.showType = this.showType === 'target' ? 'source' : 'target';
    }
  }, {
    key: "onReset",
    value: function onReset() {
      this.resetWithinCard();
      this.helpWasShown = false;
    }
  }, {
    key: "closeFeedEntry",
    value: function closeFeedEntry() {
      this.submittedToFeedMessageClosed = true;
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "textEntry", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "addToReviews", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "revealed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "helpWasShown", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "helpWord", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "submittedToFeed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "submittingToFeed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "submittedToFeedMessageClosed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "audioHasAutoPlayed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "onboardingTipSeen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "lastOnboardingTipSeen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "requestedFeedback", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "vocabCardShowsWord", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showHelp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'target';
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "grammarTipSeen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "inputValues", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "selectedOptionText", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "resetWithinCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetWithinCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markGrammarTipAsSeen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "markGrammarTipAsSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleShowType", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleShowType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onReset", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onReset"), _class.prototype), _class);
var _default = exports["default"] = CardState;